export default __webpack_public_path__ + "static/media/information.ad7dca91.png";